'use strict';

define('composer', [
	'composer/uploads',
	'composer/formatting',
	'composer/resize',
	'composer/autocomplete',
	'composer/scheduler',
	'composer/drag',
	'composer/scrollTimePicker',
	'scrollStop',
	'topicThumbs',
	'api',
	'helpers',
	'bootbox',
	'alerts',
	'hooks',
	'native',
	'composer/drag',
], function (uploads, formatting, resize, autocomplete, scheduler, drag, ScrollTimePicker, scrollStop,
	topicThumbs, api, helpers, bootbox, alerts, hooks, native) {
	var composer = {
		active: undefined,
		posts: {},
		bsEnvironment: undefined,
		formatting: undefined,
		eventReady: false,
		systemTagList: null,
		topicGroups: null,
		webViewActiveStatus: 0,
	};

	let defaultDeadline = null;

	const COMMUNITY_HOST = window.location.origin;
	// (window.COMMUNITY_URL[window.config.RTE][window.config.REGION] || '');

	$(window).off('resize', onWindowResize).on('resize', onWindowResize);
	onWindowResize();

	$(window).on('action:composer.topics.post', function (ev, data) {
		localStorage.removeItem('category:' + data.data.cid + ':bookmark');
		localStorage.removeItem('category:' + data.data.cid + ':bookmark:clicked');
	});

	function composerUploaded(data) {
		var postData = composer.posts[data.post_uuid];
		if (data.files) {
			data.files.forEach((file) => {
				if (file.url) {
					if (file.isImage || postData.isForum) {
						if (postData.imageList) {
							postData.imageList.push(file);
						} else {
							postData.imageList = [file];
						}
					} else if (postData.videoList) {
						postData.videoList.push(file);
					} else {
						postData.videoList = [file];
					}
				}
			});
		}
		if (data.videoList) {
			postData.videoList = data.videoList;
		}
	}

	function composerSaveTip(res) {
		if (res.event === 'onActiveChange' && res.data) {
			onActiveChange(res.data);
			return { status: 0 };
		}

		// 1 可以关闭，0 不能关闭
		if (!composer.webViewActiveStatus && composer.active !== undefined) {
			// 兼容编辑器已关闭，但是监听事件未注销的情况
			if ($('.composer[component="composer"]').length === 0) {
				native.off('WebView.onMessage', composerSaveTip);
				native.off('WebView.onActiveChange', onActiveChange);
				return { status: 1 };
			}
			if (res.event === 'back' || res.event === 'close' || res.event === 'closeByUrl') {
				setTimeout(() => {
					$('.composer-container .composer-navbar .btn-back').click();
				}, 100);
			}
			return { status: 0 };
		}

		return { status: 1 };
	}

	function onActiveChange(res) {
		// 0 - webview 已经进入前台
		// 2 - webview 已经进入后台
		// 4 - webview 销毁
		composer.webViewActiveStatus = res.status;
	}

	function onWindowResize() {
		var env = utils.findBootstrapEnvironment();

		if (composer.active !== undefined) {
			resize.reposition($('.composer[data-uuid="' + composer.active + '"]'));
		}
		composer.bsEnvironment = env;
	}

	function alreadyOpen(post) {
		// If a composer for the same cid/tid/pid is already open, return the uuid, else return bool false
		var type;
		var id;

		if (post.hasOwnProperty('cid')) {
			type = 'cid';
		} else if (post.hasOwnProperty('tid')) {
			type = 'tid';
		} else if (post.hasOwnProperty('pid')) {
			type = 'pid';
		}

		id = post[type];

		// Find a match
		for (var uuid in composer.posts) {
			if (composer.posts[uuid].hasOwnProperty(type) && id === composer.posts[uuid][type]) {
				return uuid;
			}
		}

		// No matches...
		return false;
	}

	function pushPost(post) {
		var uuid = utils.generateUUID();
		var existingUUID = alreadyOpen(post);

		if (existingUUID) {
			return composer.load(existingUUID);
		}

		// Construct a save_id
		if (post.hasOwnProperty('cid')) {
			post.save_id = ['composer', app.user.uid, 'cid', post.cid].join(':');
		} else if (post.hasOwnProperty('tid')) {
			post.save_id = ['composer', app.user.uid, 'tid', post.tid].join(':');
		} else if (post.hasOwnProperty('pid')) {
			post.save_id = ['composer', app.user.uid, 'pid', post.pid].join(':');
		}

		composer.posts[uuid] = post;
		composer.load(uuid);
	}

	async function composerAlert(post_uuid, message) {
		var postContainer = $('.composer[data-uuid="' + post_uuid + '"]');
		var submitBtn = postContainer.find('#composerSubmit');
		submitBtn.removeAttr('disabled');
		const { showAlert } = await hooks.fire('filter:composer.error', { post_uuid, message, showAlert: true });

		if (showAlert) {
			alerts.alert({
				type: 'danger',
				timeout: 3000,
				title: '',
				message: message,
				alert_id: 'post_error',
			});
		}
	}

	composer.findByTid = function (tid) {
		// Iterates through the initialised composers and returns the uuid of the matching composer
		for (var uuid in composer.posts) {
			if (composer.posts.hasOwnProperty(uuid) && composer.posts[uuid].hasOwnProperty('tid') && parseInt(composer.posts[uuid].tid, 10) === parseInt(tid, 10)) {
				return uuid;
			}
		}

		return null;
	};

	composer.addButton = function (iconClass, onClick, title) {
		formatting.addButton(iconClass, onClick, title);
	};

	composer.newTopic = function (data) {
		var pushData = {
			action: 'topics.post',
			cid: data.cid,
			title: data.title || '',
			body: data.body || '',
			tags: data.tags || [],
			topicGroupId: data.topicGroupId || '',
			modified: !!((data.title && data.title.length) || (data.body && data.body.length)),
			isMain: true,
		};

		$(window).trigger('filter:composer.topic.push', {
			data: data,
			pushData: pushData,
		});
		pushPost(pushData);
	};

	composer.newReply = function (data) {
		pushPost({
			action: 'posts.reply',
			tid: data.tid,
			toPid: data.toPid,
			title: data.title,
			groupPid: data.groupPid,
			groupIndex: data.groupIndex,
		});
	};

	composer.editPost = function (pid) {
		socket.emit('plugins.composer.push', pid, function (err, threadData) {
			if (err) {
				return alerts.error(err);
			}
			threadData.action = 'posts.edit';
			threadData.pid = pid;
			threadData.modified = false;
			pushPost(threadData);
		});
	};

	composer.load = function (post_uuid) {
		window.localStorage.setItem('compose_uuid', post_uuid);
		var postContainer = $('.composer[data-uuid="' + post_uuid + '"]');
		if (postContainer.length) {
			activate(post_uuid);
			resize.reposition(postContainer);
			focusElements(postContainer, post_uuid);
			onShow();
		} else if (composer.formatting) {
			createNewComposer(post_uuid);
		} else {
			socket.emit('plugins.composer.getFormattingOptions', function (err, options) {
				if (err) {
					return alerts.error(err);
				}

				composer.formatting = options;
				createNewComposer(post_uuid);
			});
		}
	};

	composer.enhance = function (postContainer, post_uuid, postData) {
		if (!post_uuid && !postData) {
			post_uuid = utils.generateUUID();
			composer.posts[post_uuid] = ajaxify.data;
			postData = ajaxify.data;
			postContainer.attr('data-uuid', post_uuid);
		}

		var submitBtn = postContainer.find('#composerSubmit');
		var tagListEl = postContainer.find('#tagList');
		var tagModal = postContainer.find('#tagModal');
		var topicGroupModal = postContainer.find('#topicGroupModal');
		var deadlineModal = postContainer.find('#deadlineModal');
		var previewModal = postContainer.find('#previewModal');
		var imgsEl = postContainer.find('.img-container');
		var videoEl = postContainer.find('.video-container');
		formatting.addHandler(postContainer, composerUploaded);
		uploads.initialize(post_uuid, postData, composerUploaded);
		autocomplete.init(postContainer, post_uuid);

		submitBtn.on('click', utils.debounce(function (e) {
			e.preventDefault();
			// Other click events bring composer back to active state which is undesired on submit
			e.stopPropagation();

			if (submitBtn.attr('disabled')) {
				return;
			}

			submitBtn.attr('disabled', true);
			post(post_uuid);
		}, 300));

		const titleTextarea = postContainer.find('.title-container textarea');

		if (titleTextarea) {
			titleTextarea.on('input', function (e) {
				if (e.target.value.includes('\n')) {
					e.target.value = e.target.value.replace(/\n/g, '');
				}
				titleTextarea[0].style.height = '48px';
				titleTextarea[0].style.height = e.target.scrollHeight + 'px';
			});
		}

		require(['mousetrap'], function (mousetrap) {
			mousetrap(postContainer.get(0)).bind('mod+enter', function () {
				post(post_uuid);
			});
		});

		postContainer.on('click', '.composer-container .composer-navbar .btn-back', function (e) {
			e.preventDefault();

			if (window.__composer_prompt__) {
				window.__composer_prompt__.modal('hide');
			}

			var postData = composer.posts[post_uuid];
			var postContainer = $('.composer[data-uuid="' + post_uuid + '"]');
			var titleEl;
			if (postData.isForum) {
				titleEl = postContainer.find('.title-container textarea');
			} else {
				titleEl = postContainer.find('.content-container textarea');
			}

			var title = titleEl.val().trim();

			if (postData.isMoment) {
				if ((!postData.imageList || postData.imageList.length === 0) &&
					(!postData.videoList || postData.videoList.length === 0) && !title) {
					if (native.mock) {
						composer.discard(post_uuid);
						window.localStorage.setItem('composeRouteState', '-1');
						window.history.go(-1);
						setTimeout(() => {
							window.localStorage.setItem('composeRouteState', '');
						}, 20);
						return;
					}
					native.off('WebView.onMessage', composerSaveTip);
					native.off('WebView.onActiveChange', onActiveChange);
					native.closeWebView();
					return;
				}
			} else if (postData.isForum) {
				if (postData.isBallot) {
					const notEmptyTitles = postData.items.filter(i => !!i.title);
					if (postData.ballotType === 'single' && postData.deadline === defaultDeadline && notEmptyTitles.length === 0 && !title) {
						if (native.mock) {
							composer.discard(post_uuid);
							window.localStorage.setItem('composeRouteState', '-1');
							window.history.go(-1);
							setTimeout(() => {
								window.localStorage.setItem('composeRouteState', '');
							}, 20);
							return;
						}
						native.off('WebView.onMessage', composerSaveTip);
						native.off('WebView.onActiveChange', onActiveChange);
						native.closeWebView();
						return;
					}
				} else {
					const check = {
						post_uuid: post_uuid,
					};
					$(window).trigger('action:composer.check', check);
					if (postData.tags.length === 0 && check.isEmpty && !title) {
						if (native.mock) {
							composer.discard(post_uuid);
							window.localStorage.setItem('composeRouteState', '-1');
							window.history.go(-1);
							setTimeout(() => {
								window.localStorage.setItem('composeRouteState', '');
							}, 20);
							return;
						}
						native.off('WebView.onMessage', composerSaveTip);
						native.off('WebView.onActiveChange', onActiveChange);
						native.closeWebView();
						return;
					}
				}
			} else if (postData.isReplay) {
				if ((!postData.imageList || postData.imageList.length === 0) && !title) {
					if (native.mock) {
						composer.discard(post_uuid);
						window.localStorage.setItem('composeRouteState', '-1');
						window.history.go(-1);
						setTimeout(() => {
							window.localStorage.setItem('composeRouteState', '');
						}, 20);
						return;
					}
					native.off('WebView.onMessage', composerSaveTip);
					native.off('WebView.onActiveChange', onActiveChange);
					native.closeWebView();
					return;
				}
			}

			window.__composer_prompt__ = bootbox.confirm({
				message: 'Leaving this page without saving changes?',
				className: 'composer-leave-save',
				callback: function (confirm) {
					if (confirm && native.mock) {
						composer.discard(post_uuid);
						window.localStorage.setItem('composeRouteState', '-1');
						window.history.go(-1);
						setTimeout(() => {
							window.localStorage.setItem('composeRouteState', '');
						}, 20);
					} else if (confirm) {
						native.off('WebView.onMessage', composerSaveTip);
						native.off('WebView.onActiveChange', onActiveChange);
						native.closeWebView();
					}
				},
			});
		});

		/** 切换投票功能 */
		postContainer.on('click', '#createBallot', function (e) {
			e.preventDefault();
			const $self = $(this);
			if ($self.hasClass('active')) {
				postContainer.find('.function-container .f-item[data-format]').attr('disabled', false);
				delete postData.isBallot;
				delete postData.deadline;
				delete postData.ballotType;
				delete postData.items;
				delete postData.currentSelectedTime;
				defaultDeadline = null;
			} else {
				postContainer.find('.function-container .f-item[data-format]').attr('disabled', true);
				postData.isBallot = true;
				postData.ballotType = 'single';
				const itemsEl = $('#ballotList .ballot-item-title');
				postData.items = [];
				for (let i = 0; i < itemsEl.length; i += 1) {
					postData.items.push({ title: itemsEl[i].value || '', count: 0 });
				}

				const defaultTime = new Date();
				const d = defaultTime.getDate();
				defaultTime.setDate(d + 1);
				defaultTime.setSeconds(0);
				defaultTime.setMilliseconds(0);
				postData.currentSelectedTime = defaultTime;
				defaultDeadline = defaultTime.getTime();
				postData.deadline = defaultDeadline;
				updateDeadline(postData.currentSelectedTime);
			}
			postContainer.find('.tags, .write-forum-container, .ballot').toggleClass('hidden');
			$self.toggleClass('active');
		});

		postContainer.on('click', '.img-remove', function (e) {
			e.preventDefault();
			e.stopPropagation();
			var imageItemEl = $(e.target).parents('.img-item');
			var index = imageItemEl.index();
			imageItemEl.remove();
			drag.remove(index);
			var imageLength = postContainer.find('.img-item').length;
			var imageMaxLength = parseInt(postContainer.find('.img-wrapper')[0].dataset.maxlength, 10);
			imgsEl.find('.img-count').text(imageLength + '/' + imageMaxLength);
			if (imageLength === 0) {
				imgsEl.addClass('hidden');
				postContainer.find('#uploadImage').prop('disabled', false).attr('disabled', false);
				postContainer.find('#uploadVideo').prop('disabled', false).attr('disabled', false);
			} else {
				postContainer.find('#uploadImage').prop('disabled', false).attr('disabled', false);
			}

			postData.imageList = postData.imageList.filter((i, idx) => idx !== index);
		});

		videoEl.on('click', '.video-remove', function (e) {
			e.preventDefault();
			videoEl.find('.iframely-container, .media-player').remove();
			videoEl.addClass('hidden');
			postContainer.find('#uploadImage').prop('disabled', false).attr('disabled', false);
			postContainer.find('#uploadVideo').prop('disabled', false).attr('disabled', false);
			postData.videoList = [];
		});

		postContainer.on('click', '.tag-select', function (e) {
			e.preventDefault();
			tagModal.find('.tag-item').removeClass('checked');
			for (var i = 0; i < postData.tags.length; i += 1) {
				for (var j = 0; j < composer.systemTagList.length; j += 1) {
					if (composer.systemTagList[j].value === postData.tags[i].value) {
						tagModal.find(`.tag-item[data-tag=${composer.systemTagList[j].sortKey}]`).addClass('checked');
					} else if (composer.systemTagList[j].children) {
						for (var k = 0; k < composer.systemTagList[j].children.length; k += 1) {
							if (composer.systemTagList[j].children[k].value === postData.tags[i].value) {
								tagModal.find(`.tag-item[data-tag=${composer.systemTagList[j].children[k].sortKey}]`).addClass('checked');
							}
						}
					}
				}
			}
			tagModal.find('.tag-modal-back').addClass('hidden');
			tagModal.find('.tag-modal-container').removeClass('show-level2-now');
			const level2 = tagModal.find('.tag-level2-list').not('.hidden');
			level2.addClass('hidden');
			tagModal.removeClass('hidden');
		});
		postContainer.on('click', '.tag-delete', function (e) {
			e.preventDefault();
			const tags = [];
			const currentTag = $(this).parents('.tag-item').attr('data-tag');

			for (let i = 0; i < postData.tags.length; i += 1) {
				let tag = null;
				let parentTag = null;
				composer.systemTagList.forEach((t) => {
					if (t.value === postData.tags[i].value) {
						tag = t;
					} else if (t.children) {
						t.children.forEach((tt) => {
							if (tt.value === postData.tags[i].value) {
								tag = tt;
								parentTag = t;
							}
						});
					}
				});

				if (!parentTag && tag && tag.sortKey === currentTag) {
					// 当前删除 tag 为一级tag
					$(`#tagList .tag-item[data-tag=${tag.sortKey}]`).remove();
				} else if (parentTag && tag && tag.sortKey === currentTag) {
					// 当前删除 tag 为二级tag
					$(`#tagList .tag-item[data-tag=${tag.sortKey}]`).remove();
				} else if (parentTag && parentTag.sortKey === currentTag) {
					// 当前删除 tag 为一级tag, 要同时删除其二级 tag
					$(`#tagList .tag-item[data-tag=${tag.sortKey}]`).remove();
				} else {
					tags.push(postData.tags[i]);
				}
			}
			postData.tags = tags;
		});
		tagModal.on('click', '.tag-item-check', function (e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).parent().toggleClass('checked');
			const tagValue = $(this).parent().attr('data-tag');
			const parentTagValue = $(this).parents('.tag-level2-list:eq(0)').attr('data-tag');
			const hasChecked = $(this).parents('.tag-item').hasClass('checked');
			const level2 = tagModal.find(`.tag-level2-list[data-tag=${tagValue}]`);
			if (!hasChecked && level2.length) {
				level2.find('.tag-item.checked').removeClass('checked');
			} else if (hasChecked && parentTagValue) {
				const level1 = tagModal.find(`.tag-modal-container>.tag-item[data-tag=${parentTagValue}]`);
				if (!level1.hasClass('checked')) {
					level1.addClass('checked');
				}
			}
		});
		tagModal.on('click', '.goLevel2', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const sortKey = $(this).parent().attr('data-tag');
			console.log('---goLevel2---', sortKey);
			const tag = composer.systemTagList.find(i => i.sortKey === sortKey);
			if (tag.children) {
				const level2 = tagModal.find(`.tag-level2-list[data-tag=${sortKey}]`);
				tagModal.find('.tag-modal-container').addClass('show-level2-now');
				level2.removeClass('hidden');
				tagModal.find('.tag-modal-cancel').addClass('hidden');
				tagModal.find('.tag-modal-back').removeClass('hidden');
			}
		});
		tagModal.on('click', '.tag-modal-back', function (e) {
			e.preventDefault();
			const level2 = tagModal.find('.tag-level2-list').not('.hidden');
			tagModal.find('.tag-modal-container').removeClass('show-level2-now');
			level2.addClass('hidden');
			tagModal.find('.tag-modal-back').addClass('hidden');
			tagModal.find('.tag-modal-cancel').removeClass('hidden');
		});
		tagModal.on('click', '.tag-modal-confirm', function (e) {
			e.preventDefault();
			const groupEl = tagListEl.find('.group-select');
			tagListEl.find('.tag-item').remove();
			const tags = [];
			for (let i = 0; i < composer.systemTagList.length; i += 1) {
				const tag = composer.systemTagList[i];
				if ($(`.tag-item[data-tag=${tag.sortKey}]`).hasClass('checked')) {
					tags.push({ sortKey: tag.sortKey, value: tag.value });
					tagListEl.append(`<div class="tag-item" data-tag="${tag.sortKey}" style="${tag.value === 'aidot works with matter' ? 'text-transform: none;' : ''}">#${helpers.formatTagAiDot(tag.value)}<i class="icon-nodeBB-remove tag-delete"></i></div>`);
					if (tag.children) {
						for (let j = 0; j < tag.children.length; j += 1) {
							const subTag = tag.children[j];
							if ($(`.tag-item[data-tag=${subTag.sortKey}]`).hasClass('checked')) {
								tags.push({ sortKey: subTag.sortKey, value: subTag.value });
								tagListEl.append(`<div class="tag-item" data-tag="${subTag.sortKey}" style="${subTag.value === 'aidot works with matter' ? 'text-transform: none;' : ''}">#${helpers.formatTagAiDot(subTag.value)}<i class="icon-nodeBB-remove tag-delete"></i></div>`);
							}
						}
					}
				}
			}

			tagListEl.append('<span class="tag-item tag-select">+ Tag</span>');
			tagListEl.append(groupEl);
			postData.tags = tags;
			tagModal.addClass('hidden');
		});
		tagModal.on('click', '.tag-modal-cancel', function (e) {
			e.preventDefault();
			tagModal.addClass('hidden');
		});

		postContainer.on('click', '.group-select', function (e) {
			e.preventDefault();
			topicGroupModal.find('.topic-group-item').removeClass('checked');
			topicGroupModal.find(`.topic-group-item[data-topicgroupid="${postData.topicGroupId || ''}"]`).addClass('checked');
			topicGroupModal.removeClass('hidden');
		});

		topicGroupModal.on('click', '.topic-group-item', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('checked') && $(this).hasClass('joined')) {
				$('.topic-group-item').removeClass('checked');
				$(this).addClass('checked');
			}
		});

		topicGroupModal.on('click', '.topic-group-join', function (e) {
			e.preventDefault();
			const topicGroupEl = $(this).parents('.topic-group-item');
			const topicGroupId = topicGroupEl.attr('data-topicgroupid');
			if (topicGroupId) {
				api.put(`/topicGroups/${topicGroupId}/join`, {}, function () {
					loadTopicGroups();
					alerts.success('Successfully');
				});
			}
		});

		topicGroupModal.on('click', '.tag-modal-confirm', function (e) {
			e.preventDefault();
			const topicGroupId = topicGroupModal.find('.topic-group-item.checked').attr('data-topicgroupid');
			if (topicGroupId && composer.topicGroups) {
				postData.topicGroupId = topicGroupId;
				const g = composer.topicGroups.find(i => i.id === topicGroupId);
				postContainer.find('.group-select').addClass('selected').attr('data-topicgroupid', g.id);
				postContainer.find('.group-selected-title').html(g.title);
			} else {
				postData.topicGroupId = '';
				postContainer.find('.group-select').removeClass('selected').attr('data-topicgroupid', '');
				postContainer.find('.group-selected-title').html('');
			}
			topicGroupModal.addClass('hidden');
		});

		topicGroupModal.on('click', '.tag-modal-cancel', function (e) {
			e.preventDefault();
			topicGroupModal.addClass('hidden');
		});

		function onTopicGroupJoin(data) {
			if (composer.active !== undefined) {
				const g = (composer.topicGroups || []).find(i => i.id === data.id);
				if (!g) {
					return;
				}
				g.joins = data.joins;
				g.initJoins = data.initJoins || 0;
				const gEl = topicGroupModal.find(`[data-topicgroupid="${data.id}"]`);
				gEl.find('.topic-group-joins').html(helpers.formatComments(g.joins + g.initJoins));

				if (data.uid !== app.user.uid) {
					return;
				}

				g.joined = data.joined;
				if (g.joined) {
					gEl.addClass('joined');
				} else {
					if (gEl.hasClass('checked')) {
						gEl.removeClass('checked');
						topicGroupModal.find(`[data-topicgroupid=""]`).addClass('checked');
					}
					gEl.removeClass('joined');

					if (g.id === postData.topicGroupId) {
						postData.topicGroupId = '';
						postContainer.find('.group-select').removeClass('selected').attr('data-topicgroupid', '');
						postContainer.find('.group-selected-title').html('');
					}
				}
			}
		}

		socket.off('event:topic_group_join', onTopicGroupJoin).on('event:topic_group_join', onTopicGroupJoin);

		postContainer.on('click', '.posting-rules', function (e) {
			e.preventDefault();
			if (native.mock) {
				window.history.pushState({
					composeRules: true,
				}, null);
				window.localStorage.setItem('rulesRouteState', '1');
				postContainer.find('.post-rules').show();
			} else {
				native.openWebView({
					url: `${COMMUNITY_HOST}/postrules?cid=${postData.cid}`,
					newWebViewCanBack: true,
					infuseJsBridge: true,
					navBar: {
						title: 'Posting Rules',
						backgroundColor: '#EDF2F7',
						backButtonColor: '#1F2429',
						titleColor: '#1F2429',
					},
					closeButton: {
						hidden: true,
					},
				});
			}
		});

		postContainer.on('click', '.post-rules .rules-item', function (e) {
			e.preventDefault();
			$(this).toggleClass('open');
		});

		postContainer.on('click', '.post-rules .btn-back', function (e) {
			e.preventDefault();
			if (native.mock) {
				postContainer.find('.post-rules').hide();
				window.localStorage.setItem('rulesRouteState', '-1');
				window.history.go(-1);
				setTimeout(() => {
					window.localStorage.setItem('rulesRouteState', '');
				}, 20);
			}
		});

		postContainer.on('click', '.ballot-type .type-item', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('selected')) {
				postContainer.find('.ballot-type .type-item').toggleClass('selected');
			}
			postData.ballotType = $(this)[0].dataset.type;
		});

		postContainer.on('input', '#ballotList input', function (e) {
			e.preventDefault();
			var v = e.target.value;
			v = (v || '').trim();
			$(this).parents('.ballot-item').find('.ballot-item-length').text(v.length + '/200');
			var index = parseInt($(this).attr('data-index'), 10);
			postData.items[index].title = v;
		});

		postContainer.on('click', '.ballot-add', function (e) {
			e.preventDefault();
			var index = postContainer.find('#ballotList .ballot-item').length;
			postContainer.find('#ballotList').append('<div class="ballot-item ballot-remove"><i class="icon-nodeBB-icon_vote_remove"></i><input class="ballot-item-title" data-index="' + index + '" placeholder="Option ' + (index + 1) + '" maxlength="200" /><span class="ballot-item-length">0/200</span></div>');
			postContainer.find('.ballot-add .ballot-item-title').text('Add Option (' + (index + 1) + '/8)');
			const newOption = {
				title: '',
				count: 0,
			};
			if (!postData.items) {
				postData.items = [newOption];
			} else {
				postData.items.push(newOption);
			}
			if (index === 7) {
				$(this).addClass('hide');
			}
		});

		postContainer.on('click', '#forumPreview', function (e) {
			e.preventDefault();
			if ($('#forumPreview').attr('disabled')) {
				return;
			}
			previewModal.removeClass('hidden');
			const titleEl = postContainer.find('.title-container textarea');
			var content = {};
			if (postData.isForum && postData.isBallot) {
				// 论坛投票
				content.type = 'ballot';
				content.value = '';
				content.multiple = postData.ballotType === 'multip';
				content.items = postData.items || [];
				content.deadline = postData.deadline;
			} else if (postData.isForum) {
				// 论坛
				var quill = $(`[data-uuid="${post_uuid}"]`).find('.ql-container').data('quill');
				content.value = quill.root.innerHTML;
			}

			const composerData = {
				uuid: post_uuid,
				title: titleEl.val(),
				content: content,
				tags: postData.tags.map(i => i.value),
			};

			app.parseAndTranslate('preview-topic', composerData, function (previewTemplate) {
				previewModal.find('.view-modal-container').html(previewTemplate);
				previewModal.find('.view-modal').scrollTop(0);
			});
		});
		previewModal.on('click', '.view-model-close', function (e) {
			e.preventDefault();
			previewModal.addClass('hidden');
		});
		postContainer.on('click', '#ballotList .icon-nodeBB-icon_vote_remove', function (e) {
			e.preventDefault();
			var ballotItemEl = $(this).parents('.ballot-item');
			var index = ballotItemEl.index();
			ballotItemEl.remove();
			var inputs = postContainer.find('#ballotList .ballot-item input');
			for (var i = 0; i < inputs.length; i += 1) {
				$(inputs[i]).attr('data-index', i);
				$(inputs[i]).attr('placeholder', 'Option ' + (i + 1));
			}
			postContainer.find('.ballot-add .ballot-item-title').text('Add Option (' + inputs.length + '/8)');
			postContainer.find('.ballot-add').removeClass('hide');
			postData.items = postData.items.filter((i, idx) => idx !== index);
		});

		postContainer.on('click', '.deadline', function (e) {
			e.preventDefault();
			const defaultTime = new Date(postData.deadline);
			postData.currentSelectedTime = defaultTime;
			const timeLabels = ['YEAR', 'MON', 'DAY', 'HOUR', 'MIN'];
			$('.scroll-multi-picker-title').html(timeLabels.map(i => `<div>${i}</div>`));
			deadlineModal.removeClass('hidden');

			ScrollTimePicker({
				timeType: 24,
				value: defaultTime,
				onChange: (v) => {
					postData.currentSelectedTime = v;
				},
			});
		});
		deadlineModal.on('click', '.tag-modal-confirm', function (e) {
			e.preventDefault();
			postData.deadline = postData.currentSelectedTime.getTime();
			updateDeadline(postData.currentSelectedTime);
			deadlineModal.addClass('hidden');
		});
		deadlineModal.on('click', '.tag-modal-cancel', function (e) {
			e.preventDefault();
			deadlineModal.addClass('hidden');
		});

		let replyLinkModal = null;
		postContainer.on('click', '#editor-toolbar_reply_link', function () {
			const replyText = $('.reply-link').text() || '';
			const replyLink = $('.reply-link').attr('data-link') || '';
			linkDialog(replyText, replyLink);
		});

		function linkDialog(text, link) {
			const form = document.createElement('form');
			const inputAttrs = 'class="bootbox-input bootbox-input-text form-control" autocomplete="off" type="text"';
			form.innerHTML =
				`<input ${inputAttrs} name="url" value="${link}" placeholder="Please enter link address">` +
				'<br>' +
				`<input ${inputAttrs} name="text" value="${link === text ? '' : text}" placeholder="Please enter link text (optional)">`;
			replyLinkModal = bootbox.dialog({
				closeButton: false,
				title: 'Insert Link',
				className: 'aidot-composer-modal',
				size: 'large',
				message: form,
				buttons: {
					cancel: {
						label: 'Cancel',
						className: 'btn-secondary btn-default',
					},
					comfirm: {
						label: 'Comfirm',
						className: 'btn-primary',
						callback: function () {
							const f = new FormData(form);
							const url = f.get('url');
							const text = f.get('text');
							return replySubmit(url, text);
						},
					},
				},
			}).on('shown.bs.modal', function () {
				const inputEl = replyLinkModal.find('input:eq(0)');
				inputEl.focus();
			});
		}

		function replySubmit(replyLink, replyText) {
			if (!replyLink) {
				alerts.alert({
					type: 'danger',
					timeout: 2000,
					title: '',
					message: 'Please enter link address!',
					alert_id: 'post_error',
				});
				return false;
			} else if (!/^https?:\/\//i.test(replyLink)) {
				alerts.alert({
					type: 'danger',
					timeout: 2000,
					title: '',
					message: "The URL should start with 'http://' or 'https://'.",
					alert_id: 'post_error',
				});
				return false;
			}

			$('.reply-link').text(replyText || replyLink);
			$('.reply-link').attr('data-link', replyLink);
			return true;
		}

		focusElements(postContainer, post_uuid);

		hooks.fire('action:composer.enhanced', {
			postContainer: postContainer,
			postData: postData,
		});
	};

	async function setSystemTags() {
		if (!composer.systemTagList) {
			let { tags } = await api.get('/api/systemTags', {});

			var isOperationUser = !!app.user.groupTitleArray.find(i => i === '官方指定账号');
			if (!isOperationUser) {
				tags = tags.filter(i => i.value !== 'roadmap');
			}

			tags.forEach((i) => {
				i.sortKey = i.value.replace(/[^_a-zA-Z0-9]/g, '-');
				if (i.children) {
					i.children.forEach((j) => {
						j.sortKey = j.value.replace(/[^_a-zA-Z0-9]/g, '-');
					});
				}
			});

			composer.systemTagList = tags;
		}


		app.parseAndTranslate('composer_tags', { systemTagList: composer.systemTagList }, function (tagsTemplate) {
			$('#composer-tags').html(tagsTemplate);
		});
	}

	async function loadTopicGroups() {
		composer.topicGroups = await api.get(`${config.relative_path}/api/topicGroups`, {});
		const topicGroupsProfile = composer.topicGroups.filter(i => i.joined).map(i => i.title);
		window.tracer.setUserProfile({ community_user_group: topicGroupsProfile });
	}

	async function setTopicGroups(postContainer, postData) {
		if (!composer.topicGroups) {
			await loadTopicGroups();
		}

		if (postData && postData.topicGroupId) {
			const g = composer.topicGroups.find(i => i.id === postData.topicGroupId);
			if (g) {
				postContainer.find('.group-select').addClass('selected').attr('data-topicgroupid', g.id);
				postContainer.find('.group-selected-title').html(g.title);
			}
		}

		app.parseAndTranslate('composer_topic_groups', { topicGroups: composer.topicGroups.map(i => ({ ...i, joins: i.joins + (i.initJoins || 0) })) }, function (html) {
			$('#composer-groups').html(html);
		});
	}

	async function createNewComposer(post_uuid) {
		var postData = composer.posts[post_uuid];
		var isTopic = postData ? !!postData.cid : false;
		var isEditing = postData ? !!postData.pid : false;
		var isGuestPost = postData ? parseInt(postData.uid, 10) === 0 : false;
		var title = postData.title.replace(/%/g, '&#37;').replace(/,/g, '&#44;');
		postData.innerTitle = title;
		postData.titleLength = title.length;
		postData.mobile = composer.bsEnvironment === 'xs' || composer.bsEnvironment === 'sm';
		postData.resizable = true;
		postData.isReplay = !isTopic;
		postData.isMoment = postData.cid === 1;
		postData.isForum = postData.cid === 2;
		postData.isTopic = isTopic;
		postData.isEditing = isEditing;
		postData.maximumTitleLength = config.maximumTitleLength;
		postData.maximumPostLength = config.maximumPostLength;
		postData.minimumTagLength = config.minimumTagLength;
		postData.maximumTagLength = config.maximumTagLength;
		postData.showHandleInput = config.allowGuestHandles &&
				(app.user.uid === 0 || (isEditing && isGuestPost && app.user.isAdmin));
		postData.formatting = composer.formatting;
		postData.privileges = app.user.privileges;
		postData.mobile = composer.bsEnvironment === 'xs' || composer.bsEnvironment === 'sm';

		await hooks.fire('filter:composer.create', {
			postData: postData,
		});

		app.parseAndTranslate('composer', postData, function (composerTemplate) {
			if ($('.composer.composer[data-uuid="' + post_uuid + '"]').length) {
				return;
			}
			composerTemplate = $(composerTemplate);
			composerTemplate.attr('data-uuid', post_uuid);

			$(document.body).append(composerTemplate);

			var postContainer = $(composerTemplate[0]);

			resize.reposition(postContainer);
			composer.enhance(postContainer, post_uuid, postData);
			activate(post_uuid);
			setSystemTags(postData);
			setTopicGroups(postContainer, postData);
			resize.handleResize(postContainer);

			if (composer.bsEnvironment === 'xs' || composer.bsEnvironment === 'sm') {
				var submitBtns = postContainer.find('.composer-submit');
				var mobileSubmitBtn = postContainer.find('.mobile-navbar .composer-submit');
				var textareaEl = postContainer.find('.write');
				var idx = textareaEl.attr('tabindex');

				submitBtns.removeAttr('tabindex');
				mobileSubmitBtn.attr('tabindex', parseInt(idx, 10) + 1);
			}

			$(window).trigger('action:composer.loaded', {
				postContainer: postContainer,
				post_uuid: post_uuid,
				composerData: composer.posts[post_uuid],
				formatting: composer.formatting,
			});

			scrollStop.apply(postContainer.find('.write'));
			focusElements(postContainer, post_uuid);
			onShow();
			drag.init();
		});
	}

	function activate(post_uuid) {
		composer.active = post_uuid;
		$(window).trigger('action:composer.activate', {
			post_uuid: post_uuid,
		});
	}

	function focusElements(postContainer, post_uuid) {
		var postData = composer.posts[post_uuid];
		var isForum = postData.isForum;
		setTimeout(function () {
			var title;
			if (isForum) {
				title = postContainer.find('.title-container textarea');
			} else {
				title = postContainer.find('.content-container textarea');
			}

			if (title.length) {
				title.focus();
			}
		}, 200);
	}

	async function post(post_uuid) {
		var postData = composer.posts[post_uuid];
		var postContainer = $('.composer[data-uuid="' + post_uuid + '"]');
		var submitBtn = postContainer.find('#composerSubmit');
		var titleEl;
		if (postData.isForum) {
			titleEl = postContainer.find('.title-container textarea');
		} else {
			titleEl = postContainer.find('.content-container textarea');
		}

		var title = titleEl.val().trim();
		titleEl.val(title);

		var bodyEl;
		if (postData.isForum) {
			bodyEl = postContainer.find('.write-forum-container textarea');
			bodyEl.val(utils.rtrim(bodyEl.val()));
		}

		var action = postData.action;
		var payload = {
			post_uuid: post_uuid,
			postData: postData,
			postContainer: postContainer,
			titleEl: titleEl,
			titleLen: titleEl.val().length,
			bodyEl: bodyEl,
			bodyLen: bodyEl ? bodyEl.val().length : -1,
		};

		await hooks.fire('filter:composer.check', payload);
		if (bodyEl) {
			$(window).trigger('action:composer.check', payload);
		}

		if (payload.error) {
			return composerAlert(post_uuid, payload.error);
		}

		if (uploads.inProgress[post_uuid] && uploads.inProgress[post_uuid].length) {
			return composerAlert(post_uuid, '[[error:still-uploading]]');
		} else if (postContainer.find('.img-item.uploading').length) {
			return composerAlert(post_uuid, '[[error:still-uploading]]');
		}

		if (postData.isForum) {
			if (payload.titleLen < 1) {
				return composerAlert(post_uuid, '[[error:title-too-short, ' + 1 + ']]');
			} else if (payload.titleLen > 200) {
				return composerAlert(post_uuid, '[[error:title-too-long, ' + 200 + ']]');
			} else if (!postData.isBallot) {
				if (payload.isEmpty || payload.bodyLen < 1) {
					return composerAlert(post_uuid, '[[error:content-too-short, ' + 1 + ']]');
				} else if (payload.bodyLen > parseInt(config.maximumPostLength, 10)) {
					return composerAlert(post_uuid, '[[error:content-too-long, ' + config.maximumPostLength + ']]');
				}
			}
		}

		let composerData = {
			uuid: post_uuid,
		};
		const method = 'post';
		let route = '';

		if (action === 'topics.post') {
			route = '/topics';
			var content = {};
			if (postData.isMoment) {
				// 朋友圈
				const imageList = postData.imageList || [];
				const ps = drag.getPositionImages(); // 排序结果
				const newList = [];
				ps.forEach(i => newList.push(imageList[i.elIndex]));
				content.imageList = newList;
				content.videoList = postData.videoList || [];
				if ((!content.imageList || content.imageList.length === 0) &&
					(!content.videoList || content.videoList.length === 0) && !title) {
					return composerAlert(post_uuid, '[[error:content-too-short, ' + 1 + ']]');
				}
			} else if (postData.isForum && postData.isBallot) {
				// 论坛投票
				content.type = 'ballot';
				content.value = '';
				content.multiple = postData.ballotType === 'multip';
				content.items = postData.items;
				content.deadline = postData.deadline;
				if (content.deadline - Date.now() < 10 * 60 * 1000) {
					return composerAlert(post_uuid, 'Select a time ten minutes later than the current.');
				}
				if (content.items.length < 2) {
					return composerAlert(post_uuid, 'Please add at least two options');
				}
				const emptyTitles = content.items.filter(i => !i.title);
				if (emptyTitles.length) {
					return composerAlert(post_uuid, 'The option cannot be empty');
				}
			} else if (postData.isForum) {
				// 论坛
				content.value = bodyEl.val();
				content.imageList = [];
				content.videoList = [];
				if (payload.originContents && payload.originContents.ops) {
					payload.originContents.ops.forEach((d) => {
						if (d.insert && (d.insert.Image || d.insert.OnlineVideo || d.insert.Video)) {
							const { id, src, poster, ...ctx } = d.insert.Image || d.insert.OnlineVideo || d.insert.Video;
							const img = postData.imageList.find(i => i.id === id);
							if (img && img.url) {
								ctx.url = img.url;
								content.value = content.value.replaceAll(src, img.url);
							}
							if (img && img.cover) {
								ctx.cover = img.cover;
								content.value = content.value.replaceAll(poster, img.cover);
							}
							if (d.insert.Image) {
								ctx.isImage = true;
							} else if (d.insert.OnlineVideo) {
								ctx.isOnlineVideo = true;
							} else if (d.insert.Video) {
								ctx.isVideo = true;
							}
							content.imageList.push(ctx);
						}
					});
				}
				if (!postData.tags.length && !postData.topicGroupId) {
					return composerAlert(post_uuid, 'The tag or group cannot be empty.');
				}
			}

			composerData = {
				uuid: post_uuid,
				title: titleEl.val(),
				content: content,
				cid: postData.cid,
			};
			// 论坛投票不需要选择tag和group
			if (!postData.isBallot) {
				composerData.tags = postData.tags.map(i => i.value);
				composerData.topicGroupId = postData.topicGroupId;
			}
		} else if (action === 'posts.reply') {
			route = `/topics/${postData.tid}`;
			if ((!postData.imageList || postData.imageList.length === 0) && !title) {
				return composerAlert(post_uuid, '[[error:content-too-short, ' + 1 + ']]');
			} else if (payload.titleLen > 1000) {
				return composerAlert(post_uuid, '[[error:content-too-long, ' + 1000 + ']]');
			}
			const imageList = postData.imageList || [];
			const newList = [];
			if (imageList.length > 0) {
				const ps = drag.getPositionImages(); // 排序结果
				ps.forEach(i => newList.push(imageList[i.elIndex]));
			}
			const replyText = $('.reply-link').text() || '';
			const replyLink = $('.reply-link').attr('data-link') || '';

			composerData = {
				uuid: post_uuid,
				tid: postData.tid,
				content: {
					value: titleEl.val(),
					link: replyLink,
					linkText: replyText,
					imageList: newList,
				},
				toPid: postData.toPid,
				groupPid: postData.groupPid,
				groupIndex: postData.groupIndex,
			};
		}

		var submitHookData = {
			composerEl: postContainer,
			action: action,
			composerData: composerData,
			postData: postData,
			redirect: true,
		};

		await hooks.fire('filter:composer.submit', submitHookData);
		hooks.fire('action:composer.submit', Object.freeze(submitHookData));

		// Minimize composer (and set textarea as readonly) while submitting
		var textareaEl = postContainer.find('.write');
		textareaEl.prop('readonly', true);

		api[method](route, composerData)
			.then((data) => {
				postData.submitted = true;

				if (action === 'topics.post') {
					// ajaxify.go(ajaxify.currentPage, null, true);
				} else if (action === 'posts.reply') {
					alerts.alert({
						alert_id: 'reply:success',
						type: 'success',
						message: 'Reply successful',
						timeout: 1000,
					});
				}

				if (window.tracer && composerData.content) {
					const c = composerData.content;
					if (composerData.cid === 1) {
						window.tracer.track('SendMoments', {
							is_text_included: !!composerData.title,
							is_image_attached: !!(c.imageList || []).length,
							is_video_attached: !!(c.videoList || []).length,
						});
					} else if (composerData.cid === 2) {
						const isVote = !!((c.items && c.items.length));
						window.tracer.track('SendPost', {
							post_theme: composerData.title,
							tag_list: composerData.tags,
							is_text_included: !!c.value,
							is_vote_post: isVote,
							is_image_attached: !!(!isVote && (c.imageList || []).filter(i => i.isImage).length),
							is_video_attached: !!(!isVote && (c.imageList || []).filter(i => !i.isImage).length),
						});
					} else if (action === 'posts.reply') {
						const $mainPost = $('.mainPost');
						const $post = $mainPost.length ? $mainPost : $(`[component="category/topic"][data-pid="${data.groupPid}"]`);
						const t = data.topic || {};
						window.tracer.track('MakeComment', {
							content_type: t.cid === 1 ? 'moment' : 'post',
							post_theme: t.title,
							is_video_attached: !!$post.find('.ql-video, .moment-media__video, .video-item').length,
							poster_id: t.uid,
						});
					}
				}

				$(window).trigger('action:composer.' + action, { composerData: composerData, data: data });
				if (native.mock) {
					composer.discard(post_uuid);
					window.localStorage.setItem('composeRouteState', '-1');
					window.history.go(-1);
					setTimeout(() => {
						window.localStorage.setItem('composeRouteState', '');
					}, 20);
				} else {
					native.off('WebView.onMessage', composerSaveTip);
					native.off('WebView.onActiveChange', onActiveChange);
					native.closeWebView();
				}
				submitBtn.attr('disabled', false);
			})
			.catch((err) => {
				// Restore composer on error
				composer.load(post_uuid);
				textareaEl.prop('readonly', false);
				composerAlert(post_uuid, err.message);
			});
	}

	function onShow() {
		$('html').addClass('composing');
		if (native.mock) {
			$('.composer-navbar').removeClass('hidden');
		} else {
			native.on('WebView.onMessage', composerSaveTip);
			native.on('WebView.onActiveChange', onActiveChange);
		}
	}

	function onHide() {
		$('body').css({ paddingBottom: 0 });
		$('html').removeClass('composing');
		app.toggleNavbar(true);
	}

	function updateDeadline(time) {
		const year = time.getFullYear();
		let month = time.getMonth();
		month = `0${month + 1}`.replace(/0(\d{2})/, '$1');
		let day = time.getDate();
		let hours = time.getHours();
		let minutes = time.getMinutes();
		day = `0${day}`.replace(/0(\d{2})/, '$1');
		minutes = `0${minutes}`.replace(/0(\d{2})/, '$1');
		hours = `0${hours}`.replace(/0(\d{2})/, '$1');
		$('#selectedDeadline').text(`${hours}:${minutes}, ${month}/${day}/${year}`);
	}

	composer.discard = function (post_uuid) {
		if (composer.posts[post_uuid]) {
			var postData = composer.posts[post_uuid];
			var postContainer = $('.composer[data-uuid="' + post_uuid + '"]');
			postContainer.remove();

			hooks.fire('action:composer.discard', {
				post_uuid: post_uuid,
				postData: postData,
			});
			delete composer.posts[post_uuid];
			composer.active = undefined;
		}
		scheduler.reset();
		onHide();
	};

	composer.close = composer.discard;

	composer.updateThumbCount = function (uuid, postContainer) {
		const composerObj = composer.posts[uuid];
		if (composerObj.action === 'topics.post' || (composerObj.action === 'posts.edit' && composerObj.isMain)) {
			const calls = [
				topicThumbs.get(uuid),
			];
			if (composerObj.pid) {
				calls.push(topicThumbs.getByPid(composerObj.pid));
			}
			Promise.all(calls).then((thumbs) => {
				thumbs = thumbs.reduce((memo, cur) => {
					memo = memo.concat(cur);
					return memo;
				});

				if (thumbs.length) {
					const formatEl = postContainer.find('[data-format="thumbs"]');
					formatEl.attr('data-count', thumbs.length);
				}
			});
		}
	};

	return composer;
});
